import React, {useEffect, useState} from "react";
import Select from "react-select";
import renderUtils from "../../../helpers/renderUtils";
import { useTranslation } from 'react-i18next';

const PartType = ({formatPart, setConfigurations, configurations, partTypes, readOnly}) => {

    const { t } = useTranslation();

    const [configuration, setConfiguration] = useState()

    useEffect(() => {
        setConfiguration(configurations.find(c => c.formatPart.id === formatPart.id))
    }, [configurations])

    const handleTypeChange = (selectedOption) => {

        // Update the specific configuration
        const updatedConfigurations = configurations.map(config => {
            if (config.formatPart.id === formatPart.id) {
                // Return a new object with the updated type field
                return {
                    ...config,
                    type: selectedOption
                };
            }
            return config;
        });

        setConfigurations(updatedConfigurations);
    };

    return <>
        {
            readOnly ?
                <>
                    {configuration?.type?.label}
                </> :
                <>
                    {
                        partTypes &&
                        <Select
                            value={configuration?.type || null} // Handle potential undefined values
                            onChange={handleTypeChange}
                            isDisabled={!configuration || readOnly}
                            isClearable
                            classNamePrefix={""} // Update based on your styles
                            placeholder={t("forms.choose")}
                            options={partTypes.map(v => {
                                return {value: v, label: renderUtils.renderEnumName(v, "enums/partType", t)};
                            })}
                        />

                    }
                </>
        }
    </>;
}

export default PartType;